// External modules
import React, { useState, useContext, useEffect } from 'react';
import { useMappedState } from 'redux-react-hook';
import { Set } from 'immutable';

// User-land modules
import FirebaseContext from '../../components/Firebase/context';
import { getDocs } from '../../utils';
import { CollectionRecord } from '../../records/collection';
import ShipCard from '../../components/ShipCard';
// import shipsList from '../../const/ships.1.json';
import * as styles from '../../screens/Home/styles.module.css';

function useCollection(ownerId) {
  const { firebase } = useContext(FirebaseContext);
  const [collection, setCollection] = useState({ id: 0, name: '', ships: [] });

  useEffect(() => {
    if (collection.id) return () => {};

    const db = firebase.firestore();
    const collectionRef = db.collection('collections');
    const query = collectionRef.where('owner', '==', ownerId);
    query.get().then((querySnapshot) => {
      const collection = getDocs(querySnapshot).pop() || { id: 0, data: {} };
      const collectionRecord = CollectionRecord({
        id: collection.id,
        name: collection.data.name,
        owner: collection.data.owner,
        ships: Set(collection.data.ships),
      });

      setCollection(collectionRecord);
    });
    return () => {};
  });
  return collection;
}

function noop() {}

function alwaysTrue() {
  return true;
}

export default function GuestCollectionPreview({ match }) {
  const mapState = (state) => ({
    myShips: state.getIn(['collection', 'ships']),
    myId: state.getIn(['user', 'id']),
    shipsList: state.getIn(['ships']),
  });
  const { myShips, myId, shipsList: _shipsList } = useMappedState(mapState);
  const targetId = match.params.id;
  const viewingMyCollection = targetId === myId;

  const shipsList = _shipsList.toJS();

  const guestCollection = useCollection(targetId);

  const ships = shipsList.filter((ship) =>
    guestCollection.ships.includes(ship.name),
  );
  const shipsIDontOwn = ships.filter((ship) => !myShips.has(ship.name));
  const _shipsTargetDontOwn = myShips.filter(
    (ship) => !guestCollection.ships.includes(ship),
  );
  const shipsTargetDontOwn = shipsList.filter((ship) =>
    _shipsTargetDontOwn.has(ship.name),
  );

  return (
    <div>
      <h1 className="text-center">
        {viewingMyCollection ? 'My' : guestCollection.name} Collection
      </h1>

      {!viewingMyCollection && (
        <div style={{ width: 860, margin: 'auto', lineHeight: '1.4' }}>
          <h4 style={{ marginBottom: 8 }}>Ships I do not own</h4>
          <div>{shipsIDontOwn.map((ship) => ship.name).join(', ')}</div>

          <h4 style={{ marginBottom: 8 }}>
            Ships {guestCollection.name} doesn't own
          </h4>
          <div>{shipsTargetDontOwn.map((ship) => ship.name).join(', ')}</div>
        </div>
      )}

      <div className={styles.ShipList}>
        {ships.map((ship) => (
          <ShipCard
            key={ship.id}
            id={ship.id}
            icon={ship.icon}
            name={ship.name}
            rarity={ship.rarity}
            onClick={noop}
            existInCollection={alwaysTrue}
          />
        ))}
      </div>
    </div>
  );
}
